module.exports = __webpack_public_path__ + "img/frente.0d503eaa.png";